<div class="flex gap-4 flex-col">
  @for (item of items$ | async; track $index) {
    @if (!!item.redirect) {
      <a
        app-button
        [href]="item.redirect"
        [target]="item.target || '_blank'"
        class="group cursor-pointer hover:brightness-100! transition overflow-hidden justify-start! duration-300 items-center p-4 gap-3 w-full border-b-[3px] border-solid! rounded-xl"
        [ngClass]="item.style"
      >
        <svg-icon
          class="group-hover:transition group-hover:duration-300 w-8 h-8 block group-hover:text-white"
          [ngClass]="item.iconStyle"
          [src]="item.icon | icon"
        ></svg-icon>

        <div class="group-hover:transition z-50 items-start group-hover:duration-300 flex justify-center flex-col">
          <h1 class="group-hover:text-white leading-tight text-lg font-semibold" [ngClass]="item.textStyle">
            {{ item.title | translate }}
          </h1>
          <h3 class="group-hover:text-white leading-tight text-md font-normal">{{ item.product | translate }}</h3>
        </div>
        <div class="absolute w-20 h-20 block -rotate-25 right-0 bottom-0 z-0">
          <svg-icon [ngClass]="item.bgStyle" [src]="item.icon | icon"></svg-icon>
        </div>
        <ng-container *ngTemplateOutlet="ribbon; context: { $implicit: item }"></ng-container>
      </a>
    } @else if (item?.open) {
      <button
        app-button
        [disabled]="item.load()"
        type="button"
        (click)="onOpen(item)"
        class="group cursor-pointer hover:brightness-100! transition overflow-hidden justify-start! duration-300 items-center p-4 gap-3 w-full border-b-[3px] border-solid! rounded-xl"
        [ngClass]="item.style"
      >
        @if (item.load()) {
          <app-skeleton
            [showLabel]="false"
            baseStyle="rounded-xl bg-base-gray-light-400"
            class="absolute top-0 left-0"
          ></app-skeleton>
        }
        <svg-icon
          class="group-hover:transition group-hover:duration-300 w-8 h-8 block group-hover:text-white"
          [ngClass]="item.iconStyle"
          [src]="item.icon | icon"
        ></svg-icon>

        <div class="group-hover:transition z-50 items-start group-hover:duration-300 flex justify-center flex-col">
          <h1 class="group-hover:text-white leading-tight text-lg font-semibold" [ngClass]="item.textStyle">
            {{ item.title | translate }}
          </h1>
          <h3 class="group-hover:text-white leading-tight text-md font-normal">{{ item.product | translate }}</h3>
        </div>
        <div class="absolute w-20 h-20 block -rotate-25 right-0 bottom-0 z-0">
          <svg-icon [ngClass]="item.bgStyle" [src]="item.icon | icon"></svg-icon>
        </div>
        <ng-container *ngTemplateOutlet="ribbon; context: { $implicit: item }"></ng-container>
      </button>
    } @else {
      <a
        app-button
        [routerLink]="routerLink(item)"
        [queryParams]="item.params"
        class="group cursor-pointer hover:brightness-100! transition overflow-hidden justify-start! duration-300 items-center p-4 gap-3 w-full border-b-[3px] border-solid! rounded-xl"
        [ngClass]="item.style"
      >
        <svg-icon
          class="group-hover:transition group-hover:duration-300 w-8 h-8 block group-hover:text-white"
          [ngClass]="item.iconStyle"
          [src]="item.icon | icon"
        ></svg-icon>

        <div class="group-hover:transition z-50 items-start group-hover:duration-300 flex justify-center flex-col">
          <h1 class="group-hover:text-white leading-tight text-lg font-semibold" [ngClass]="item.textStyle">
            {{ item.title | translate }}
          </h1>
          <h3 class="group-hover:text-white leading-tight text-md font-normal">{{ item.product | translate }}</h3>
        </div>
        <div class="absolute w-20 h-20 block -rotate-25 right-0 bottom-0 z-0">
          <svg-icon [ngClass]="item.bgStyle" [src]="item.icon | icon"></svg-icon>
        </div>
        <ng-container *ngTemplateOutlet="ribbon; context: { $implicit: item }"></ng-container>
      </a>
    }
  }
</div>

<ng-template #ribbon let-item>
  @if (item.new) {
    <span
      [ngClass]="item.iconStyle"
      class="absolute right-0 top-1/2 z-10 -translate-y-1/2 bg-current py-1 pr-3 pl-4 [clip-path:polygon(0_0,100%_0,100%_100%,0_100%,6px_50%)] group-hover:bg-white"
    >
      <span class="text-xs font-bold uppercase tracking-wide text-white group-hover:text-inherit">
        {{ 'geral.novo' | translate }}
      </span>
    </span>
  }
</ng-template>
